import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import keylogo from '../assets/key_logo.png';



const Footer: React.FC = () => {
  return (
    <footer className="bg-dark-gray text-white">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">

            <div className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center">
              <img
                src={keylogo}
                alt="Golden Generation Logo"
                className="w-full h-full object-cover scale-150"
                style={{ transform: 'scale(1.5) translateX(-2%)' }}
              />
            </div>



              <div>
                <h3 className="text-lg font-bold">GOLDEN GENERATION</h3>
                <p className="text-sm text-golden">INVESTMENT PARTNERS</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Restoring the Past, Investing in the Future. We specialize in transforming 
              historic properties into modern, valuable investments while preserving their 
              timeless character.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61577843392607" className="text-gray-400 hover:text-golden transition-colors" target="_blank" rel="noreferrer">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/goldengeneration.ip/" className="text-gray-400 hover:text-golden transition-colors" target="_blank" rel="noreferrer">
                <Instagram size={20} />
              </a>
              <a href="https://www.youtube.com/@GoldenGeneration_ip" className="text-gray-400 hover:text-golden transition-colors" target="_blank" rel="noreferrer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path d="M23.498 6.186a2.99 2.99 0 0 0-2.107-2.11C19.622 3.5 12 3.5 12 3.5s-7.622 0-9.39.576a2.99 2.99 0 0 0-2.107 2.11C0 8.003 0 12 0 12s0 3.997.503 5.814a2.99 2.99 0 0 0 2.107 2.11C4.378 20.5 12 20.5 12 20.5s7.622 0 9.391-.576a2.99 2.99 0 0 0 2.107-2.11C24 15.997 24 12 24 12s0-3.997-.502-5.814zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/>
                </svg>
              </a>
            </div>


          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-golden">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-golden transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-golden transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/developments" className="text-gray-300 hover:text-golden transition-colors">
                  Developments
                </Link>
              </li>
              <li>
                <Link to="/customer-care" className="text-gray-300 hover:text-golden transition-colors">
                  Customer Care
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-golden">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-golden" />
                <span className="text-gray-300 text-sm">goldengeneration.ip@gmail.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-golden" />
                <span className="text-gray-300 text-sm">+1 (832) 535-7744</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin size={16} className="text-golden" />
                <span className="text-gray-300 text-sm">11929 W Airport Blvd , Houston, TX, United States, 77477</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 Golden Generation Investment Partners. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
